import "./style.css";
import Atom from "../../atom";
import React, { useState } from "react";
import { CounterProps } from "../@types/counter";
import clsx from "clsx";

export default function Counter(props: CounterProps) {
  const { value, getValue, min, max, size = "sm", className, ...other } = props;

  const [state, setState] = useState(value || 0);

  const handleGetInputVal = (value: string) => {
    const num = +value;
    if (checkForMax(num) && checkForMin(num)) {
      setState(num);
      getValue?.(num);
    }
  };

  const checkForMax = (value: number) => {
    if ((max || max === 0) && value <= max) {
      return true;
    } else if (!max) {
      return true;
    }
    return false;
  };

  const checkForMin = (value: number) => {
    if ((min || min === 0) && value >= min) {
      return true;
    } else if (min === undefined) {
      return true;
    }
    return false;
  };

  const increase = () => {
    const value = state + 1;
    if ((max || max === 0) && value <= max) {
      setState(value);
      getValue?.(value);
    } else if (!max) {
      setState(value);
      getValue?.(value);
    }
  };

  const decrease = () => {
    const value = state - 1;
    if ((min || min === 0) && value >= min) {
      setState(value);
      getValue?.(value);
    } else if (min === undefined) {
      setState(value);
      getValue?.(value);
    }
  };

  return (
    <React.Fragment>
      {size === "sm" ? (
        <Atom.Div className={clsx("d-flex counterWrapper", className)}>
          <Atom.Icon
            name="plus"
            className="text-primary mt-1 mx-1"
            onClick={increase}
          />
          <Atom.GInput
            value={state}
            type="number"
            className="hideArrow smInput"
            getValue={handleGetInputVal}
            {...other}
          />
          <Atom.Icon
            name="minus"
            className="text-primary mt-1 mx-1"
            onClick={decrease}
          />
        </Atom.Div>
      ) : (
        ""
      )}

      {size === "lg" ? (
        <Atom.Div className={clsx("d-flex counterWrapper", className)}>
          <Atom.Button className="btn" onClick={increase}>
            <Atom.Icon name="plus" className="text-primary mt-1 mx-1" />
          </Atom.Button>

          <Atom.GInput
            value={state}
            type="number"
            className="hideArrow lgInput"
            getValue={handleGetInputVal}
            {...other}
          />
          <Atom.Button className="btn" onClick={decrease}>
            <Atom.Icon name="minus" className="text-primary mt-1 mx-1" />
          </Atom.Button>
        </Atom.Div>
      ) : (
        ""
      )}
    </React.Fragment>
  );
}
